import { fetchSinToken } from "../../helpers/fetch";

export const sendEmail = (email) => {
    return async (dispatch) => {

        const resp = await fetchSinToken('/api/auth/recuperar', { "email": email, }, 'POST');
        const body = await resp.json();
        console.log(body);
        console.log("validando fetch");

        if (resp.status === 200) {
            console.log(body);
            console.log("EXITOSO");
            dispatch({
                type: 'SUCCESS',
                payload: body,
            });
        } else {
            console.log("ERROR");
            dispatch({
                type: 'FAILURE',
                payload: body.errors || 'Error sending email',
            });
            throw new Error(body.errors || 'Error sending email');
        }
    }

}

